import { clsx } from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import {
  IconEmoji,
  BannerPlaceholder,
} from '@tribeplatform/react-components/common/components'
import type { StaticField } from '@tribeplatform/react-components/Views'
import { Avatar, avatarSizeClasses } from '@tribeplatform/react-ui-kit/Avatar'

import { getEmoji, getMedia } from '../utils/index.js'

interface Props {
  field: StaticField
  space: Space
  highlighted: boolean
}
export const ListImage = ({ field, space, highlighted }: Props) => {
  const imageSource = field.settings?.bannerSource
  const mediaUrl = getMedia({
    source: imageSource,
    space,
    size: 'small',
  })
  const emojiText = getEmoji({
    source: imageSource,
    space,
  })

  if (mediaUrl || imageSource !== 'image') {
    return (
      <div className="shrink-0">
        {!mediaUrl ? (
          <BannerPlaceholder
            className={clsx(
              'h-16 w-16 flex justify-center items-center rounded-base',
              'overflow-hidden',
              highlighted && 'ring-2 ring-offset-surface ring-focused',
            )}
            name={space?.relativeUrl}
          />
        ) : (
          <Avatar
            size={field.settings?.avatarSize ?? 'lg'}
            src={mediaUrl}
            name={space.name}
            rounded="base"
            className={clsx(
              highlighted &&
                'ring-2 ring-offset-surface ring-focused rounded-base',
            )}
          />
        )}
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'shrink-0 flex items-center justify-center',
        highlighted && 'ring-2 ring-offset-surface ring-focused rounded-md',
        avatarSizeClasses[field.settings?.avatarSize ?? 'lg'],
      )}
    >
      <IconEmoji text={emojiText} size={field.settings?.avatarSize ?? 'lg'} />
    </div>
  )
}
